<div class="bkg">
    <div class="header" data-aos="zoom-in-up">והתגובות של השחקנים שלא רצו להפסיק:</div>
    <div id="carouselSlides_part10" class="carousel slide" data-interval="false">
        <ol class="carousel-indicators">
            <li data-target="#carouselSlides_part10" *ngFor="let text of lstText;let i=index ;let isFirst = first"
                [attr.data-slide-to]="i" [ngClass]="{active:isFirst}"></li>

        </ol>

        <div class="carousel-inner">
            <div *ngFor="let text of lstText;let i=index;let isFirst = first" class="carousel-item"
                [ngClass]="{active:isFirst}">
                <div class="text-wraper">
                    <p class="text" [innerHtml]="text" data-aos="zoom-in-up">

                    </p>
                </div>
            </div>
        </div>

        <a class="carousel-control-prev" href="#carouselSlides_part10" role="button" data-slide="next">
            <span class="wrap-arrow">
                <span class="icon icon-new-arrow-left2"></span>
            </span>
        </a>
        <a class="carousel-control-next" href="#carouselSlides_part10" role="button" data-slide="prev">
            <span  class="wrap-arrow">
                <span class="icon icon-new-arrow-right2"></span>
            </span>
        </a>
    </div>
</div>